import Vue from 'vue'
import VueRouter from 'vue-router'
import TokenService from '../services/storage.service'
import Code from '../views/Code.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'

import Customers from  '../views/Customers.vue'
import Customer from  '../views/Customer.vue'
import NewCustomer from '../views/NewCustomer.vue'

import Cleaner from  '../views/Cleaner.vue'

import Jobs from '../views/Jobs.vue'
import Job from '../views/Job.vue'
import NewJob from '../views/NewJob.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Login,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/newcustomer',
    name: 'New Customer',
    component: NewCustomer,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/customer/:id',
    name: 'Customer',
    component: Customer,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'cleaners/customers/get',
      title: 'Customer',
      key: 'customer'
    }
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'cleaners/customers/all?page=',
      title: 'All Customers',
      key: 'all'
    }
  },
  {
    path: '/cleaner/:id',
    name: 'Cleaner',
    component: Cleaner,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'cleaners/cleaner/get',
      title: 'Cleaner',
      key: 'cleaner'
    }
  },
  {
    path: '/code',
    name: 'Code',
    component: Code,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: Jobs,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'cleaners/jobs/all?page=',
      title: 'Cleaning Jobs',
      key: 'all'
    }
  },
  {
    path: '/job/:id',
    name: 'Job',
    component: Job,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'cleaners/job/get',
      title: 'Job',
      key: 'job'
    }
  },
  {
    path: '/newjob',
    name: 'New Job',
    props: true,
    component: NewJob,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/dashboard')
  }
  next();
}) 

export default router